var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttentionBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4813 47.594C28.3367 47.5977 31.1646 47.037 33.8026 45.9443C36.4406 44.8516 38.8367 43.2483 40.853 41.2266C42.8748 39.2102 44.478 36.8142 45.5708 34.1762C46.6635 31.5382 47.2241 28.7102 47.2204 25.8549C47.2241 22.9995 46.6634 20.1716 45.5707 17.5336C44.478 14.8956 42.8747 12.4995 40.853 10.4831C38.8367 8.46142 36.4406 6.85813 33.8026 5.7654C31.1646 4.67267 28.3367 4.11204 25.4813 4.11574C22.626 4.1121 19.798 4.67275 17.1601 5.76548C14.5221 6.85821 12.126 8.46147 10.1096 10.4831C8.08793 12.4995 6.48467 14.8956 5.39195 17.5336C4.29922 20.1716 3.73857 22.9995 3.74221 25.8549C3.73851 28.7102 4.29913 31.5382 5.39186 34.1762C6.48459 36.8142 8.08788 39.2102 10.1096 41.2266C12.126 43.2482 14.5221 44.8515 17.1601 45.9442C19.798 47.037 22.626 47.5976 25.4813 47.594Z",
    fill: "#4369B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.835 35.0347C25.7412 35.1285 25.6141 35.1812 25.4814 35.1812C25.3488 35.1812 25.2217 35.1285 25.1279 35.0347C25.0341 34.9409 24.9814 34.8138 24.9814 34.6812C24.9814 34.5485 25.0341 34.4214 25.1279 34.3276C25.2217 34.2338 25.3488 34.1812 25.4814 34.1812C25.6141 34.1812 25.7412 34.2338 25.835 34.3276C25.9288 34.4214 25.9814 34.5485 25.9814 34.6812C25.9814 34.8138 25.9288 34.9409 25.835 35.0347Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4814 16.0723L25.4814 30.2027L25.4814 16.0723Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4814 16.0723L25.4814 30.2027",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionBlue);
export default __webpack_public_path__ + "static/media/attention-blue.3f801b41ede8d19d37dfce18af3d2298.svg";
export { ForwardRef as ReactComponent };